export default __webpack_public_path__ + "static/viinitie-banner-xmass-desktop-narrow.f85130c58d38f1fce0d6e9910c4113dc.jpg";